import React, { useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import DOMPurify from "dompurify";


export default function Freeze({
  currentQuestion,
  setCurrentQuestion
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [currentImg, setCurrentImg] = useState(0)

  function nextQuestion() {
    setCurrentQuestion(prev =>
      prev <= gameQuestionsQuery.content.length - 1 ? ++prev : prev
    );
  }



  return (
    <section className={`game-page freeze-mechanics ${ident}`}>
      <div>
         <PagesHeader back>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
                    }}
                  ></p>
                </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
             <LinearGradientProgressBar
                         value={currentQuestion / gameQuestionsQuery.content.length}
                       />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                }}
              />
            </div>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            <div className="freeze-wrapper">
              <div className="image-wrapper">
                { gameQuestionsQuery.content[currentQuestion].answers.map((img, i) => {
                  return (
                    <img key={i} src={img.image} className={currentImg === i ? "show" : ""} alt="" onClick={() => {
                      if(currentImg < gameQuestionsQuery.content[currentQuestion]?.answers?.length - 1) setCurrentImg(currentImg+1)
                    }}/>
                  )
                }) }
              </div>
            </div>
                 {XGA && (
                          // replace "StickyContent" with something called respectively
                          <StickyContent>
                            
                            <div className="desktop-buttons">
                              <Button  disabled={currentImg !== gameQuestionsQuery.content[currentQuestion]?.answers?.length - 1}
              action={nextQuestion}>
                                {gameQuestionsQuery.content[currentQuestion]
                                  .nextButtonCopy ?? "Nächste"}
                              </Button>
                            </div>
                          </StickyContent>
                        )}
          </div>
       
        </div>
      </div>
   {!XGA && (
        // replace with "StickyContent"
        <StickyButton
          disabled={currentImg !== gameQuestionsQuery.content[currentQuestion]?.answers?.length - 1}
              action={nextQuestion}
        
        >
          {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
            "Nächste"}
        </StickyButton>
      )}
   
    </section>
  );
}
